import type {VesselTag} from '@/api/vessels/vessel-tags'
import type {GuidType} from '@/values/generic-type-definitions'
import type {Vessel} from './vessel-selector.types'

export function getVesselSummaryDisplayData(
    vesselsWithTags: Vessel[],
    selectedVesselIds: Set<GuidType>,
) {
    let isAllSelected = true

    // Loop over all vessels and their tags and keep a counter of total vessels per tag (one tag can have many vessels)
    const tagTotals = new Map<GuidType, {tag: VesselTag; total: number; selected: number}>()
    for (const vessel of vesselsWithTags) {
        if (!vessel.tags) {
            continue
        }
        for (const tag of vessel.tags) {
            const tagWithTotal = tagTotals.get(tag.identity)
            if (tagWithTotal) {
                tagWithTotal.total++
            } else {
                tagTotals.set(tag.identity, {tag, total: 1, selected: 0})
            }
        }
    }

    const selectedVessels: Vessel[] = []
    for (const vessel of vesselsWithTags) {
        // Automatically set isAllSelected to false the moment it finds an unselected vessel
        if (!selectedVesselIds.has(vessel.location)) {
            isAllSelected = false
            continue
        }
        selectedVessels.push(vessel)
        // Go through the tagTotals and increment the selected count
        if (!vessel.tags) {
            continue
        }
        for (const tag of vessel.tags) {
            const tagWithTotal = tagTotals.get(tag.identity)
            if (tagWithTotal) {
                tagWithTotal.selected++
            }
        }
    }

    const selectedTagMap = new Map<GuidType, VesselTag>()
    for (const tagWithCount of tagTotals.values()) {
        // Tag is "selected" and will only show up in summary only when all its children vessels are selected
        if (tagWithCount.total === tagWithCount.selected) {
            selectedTagMap.set(tagWithCount.tag.identity, tagWithCount.tag)
        }
    }

    return {isAllSelected, selectedVessels, selectedTags: [...selectedTagMap.values()]}
}
